export default "__VITE_ASSET__DK4LIn4V__"